module.exports = __webpack_public_path__ + "img/2b5b4de.jpg";